import { elements } from '#components/generics/js/styles.js'
import contract from '@mailobj-browser/front/js/contracts/contract.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import wait from '@mailobj-browser/front/js/utils/wait.js'
import { get } from '#utilities/js/ea/ajax.js'
import href from '#utilities/js/ea/href.js'
import * as utilities from '#utilities/js/styles.js'
import dir from './dir.js'
import fav from './fav.js'
import opener from './opener.js'
import parent from './parent.js'

export default contract({
  dir: array([
    dir
  ]),
  fav: array([
    fav
  ]),
  opener: array([
    opener
  ]),
  parent: array([
    parent
  ]),
})

export const init = async (wrapper) => {
  const url = href('docs/req_xfiles_getdocs')
  let promise = get(url, { target: wrapper })
  const loader = one(`.${elements.loader}`, wrapper)

  queueMicrotask(async () => {
    await wait(1000)

    if (promise) {
      if (loader) {
        loader.classList.remove(utilities.modifiers.display.none)
      }
    }
  })

  await promise
  promise = null
  if (loader) {
    loader.classList.add(utilities.modifiers.display.none)
  }
}